import { render, staticRenderFns } from "./synthesisData.vue?vue&type=template&id=565af104&scoped=true&"
import script from "./synthesisData.vue?vue&type=script&lang=js&"
export * from "./synthesisData.vue?vue&type=script&lang=js&"
import style0 from "./synthesisData.vue?vue&type=style&index=0&id=565af104&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565af104",
  null
  
)

export default component.exports